export const LOCAL_TIXPIX = "http://localhost:3000";

export async function probeLocalPrinter(): Promise<boolean> {
  try {
    const response = await fetch(`${LOCAL_TIXPIX}/api/local-printer`, {
      signal: AbortSignal.timeout(1200),
    });
    if (!response.ok) return false;
    const status = (await response.json()) as { available?: boolean };
    return status.available === true;
  } catch {
    return false;
  }
}
